import { render, staticRenderFns } from "./HtmlFrame.vue?vue&type=template&id=49c6e8dc&scoped=true"
import script from "./HtmlFrame.vue?vue&type=script&lang=js"
export * from "./HtmlFrame.vue?vue&type=script&lang=js"
import style0 from "./HtmlFrame.vue?vue&type=style&index=0&id=49c6e8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c6e8dc",
  null
  
)

export default component.exports